import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const PostListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  column-gap: 30px;
  row-gap: 30px;

  @media (${mediaQuery.tablet}) {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
`;
